const listBanks = [
  {
    bankCode: 41,
    bankName: 'BANCO DO ESTADO DO RIO GRANDE',
  },
]

export default { listBanks }
